import dayjs, { extend } from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';

import { UtilDateInvalidFormatDurationArgumentError } from './util-date-invalid-format-duration-argument-error';

export const formatDurationFromSeconds = (seconds: number): string => {
  if (seconds > 0) {
    extend(durationPlugin);

    return dayjs.duration(seconds, 'seconds').format('HH:mm:ss').replace(/^00:/, '');
  }

  throw new UtilDateInvalidFormatDurationArgumentError(
    'duration value must be greater than zero'
  );
};
